import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
import Typography from '../../base/Typography';

export const ValidationErrorLabelStyled = styled(Typography)`
  display: block;
  padding-top: ${rem(3)};
`;

export const ValidationErrorLabelLeads = styled.div`
  ${({ theme }) => css`
    position:relative;
    display: inline-block;
    padding: ${rem(5)} ${rem(10)};
    background-color:${theme.colors.system.negativeError};
    border-radius:${rem(3)};
    ::before {
      content: '';
      width: 0;
      height: 0;
      border-left: solid ${rem(6)} transparent;
      border-right: solid ${rem(6)} transparent;
      border-bottom: solid ${rem(6)} ${theme.colors.system.negativeError};
      background-color: transparent;
      position: absolute;
      top: ${rem(-6)};
      left: ${rem(11)};
      transform: translateX(-50%) translateY(0);
    }
  `}
`;
